import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../../types/store';
import { Props } from './FolderDescription';
import { getSubfolders } from '../../../../../selectors/folders';
import get from 'lodash/get';

export type StateProps = Pick<Props, 'subFolders'>;
export type OwnProps = Without<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps: OwnProps
) => ({
  subFolders: getSubfolders(state, get(ownProps, 'folder.folderId')),
});

export default connect(mapStateToProps);
